<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ $t(`${namespace}.title`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-tooltip
        v-if="claims.employee['ROLE_POST_EMPLOYEE_ID_RESENDWELCOMEEMAIL']"
        slot="append"
        min-width="177"
        max-width="177"
        top
      >
        <v-btn
          color="gray-6"
          class="mx-0"
          slot="activator"
          flat
          icon
          @click="handleResendWelcomeEmail"
        >
          <v-icon>email</v-icon>
        </v-btn>
        <span>{{ $t('Common.sendWelcomeEmail') }}</span>
      </v-tooltip>

      <v-tooltip
        v-if="claims.employee['ROLE_PUT_EMPLOYEE_ID_ADDTOALLCOSTCENTERS']"
        slot="append"
        min-width="177"
        max-width="177"
        top
      >
        <v-btn
          color="gray-6"
          class="mx-0"
          slot="activator"
          flat
          icon
          @click="handleAddToAllCostCenters"
        >
          <v-icon>supervised_user_circle</v-icon>
        </v-btn>
        <span>{{ $t('Views.EmployeesPage.addToAllCostCenters') }}</span>
      </v-tooltip>

      <v-menu
        v-if="claims.employee['ROLE_PUT_EMPLOYEE_ID'] || claims.employee['ROLE_DELETE_EMPLOYEE_ID']"
        offset-y
        left
      >
        <v-btn class="btn--more_vertical mx-0" color="gray-6" slot="activator" flat icon>
          <v-icon>more_vertical</v-icon>
        </v-btn>

        <v-list class="dropdown-menu-actions__list">
          <v-list-tile
            v-if="claims.employee['ROLE_PUT_EMPLOYEE_ID']"
            @click="$router.push({
              name: 'Employee',
              params: { type: 'editar', id: data.employee.id }
            })"
          >
            <v-list-tile-title>
              {{ $t('Common.editEmployee') }}
            </v-list-tile-title>
          </v-list-tile>

          <v-divider v-if="claims.employee['ROLE_PUT_EMPLOYEE_ID'] && claims.employee['ROLE_DELETE_EMPLOYEE_ID']" />

          <v-list-tile
            v-if="claims.employee['ROLE_DELETE_EMPLOYEE_ID']"
            @click="openSingleDeleteDialog"
          >
            <v-list-tile-title>{{ $t('Common.deleteEmployee') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close(false)"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <SingleDeleteDialog
      :visible="singleDeleteDialog"
      :item="data.employee"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SingleDeleteDialog from 'components/employees/dialogs/SingleDeleteDialog'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    data: {
      type: Object,
      required: true
    }
  },
  components: {
    SingleDeleteDialog
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.employee.header',
      singleDeleteDialog: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleResendWelcomeEmail () {
      try {
        const { id, name } = this.data.employee
        await this.$apiService.resendWelcomeEmail(id)
        this.showAlert({
          type: 'success',
          message: `${this.$t(`${this.namespace}.sucessResendEmail`)} ${name}`
        })
      } catch (err) {
        console.log('ERROR:', err)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.errorResendEmail`)
        })
      }
    },

    async handleAddToAllCostCenters () {
      try {
        const employeeId = this.data.employee.id
        await this.$apiService.addToAllCostCenters(employeeId)

        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.addToAllCostCentersSuccess`)
        })

        this.$emit('reload')
      } catch (err) {
        console.log('ERROR:', err)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.addToAllCostCentersError`)
        })
      }
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
